<template>
        <div class="drag_and_match">
          <div v-sticky="{ zIndex: 999, stickyTop: 0}" class="x-column x-sm mtn x-1-3 ">
            
            <draggable class="dragBox" id="questionBox"  :options="{group:{ name:'people', pull:'clone', put:false }, sort:false}"  v-model="question.possible_draggable_options" :move="checkMove" @end="_makeChoiceAnswers($event, question);" >
                <div class="dragElement" v-for="choice in question.possible_draggable_options">{{choice}}</div>
            </draggable>
          </div>
          <div class="choices x-column x-sm mtn x-2-3 ">
            <div class="choice" v-for="choice,choiceIndex in question.drag_and_match" >




              <span v-html="choice.option"></span>
              <div class="sorry" v-if="question.commited && choice.answer.indexOf(choice.correct_match)!=0  && paid">{{choice.correct_match}}</div>

              <draggable v-if="Array.isArray(choice.answer)" :options="{group:{ name:'people'}}" class="matchBox" :data-index="choiceIndex" :key="choice.option" :move="checkMoveInner" @end="_makeChoiceAnswers($event, question);" v-model="question.drag_and_match[choiceIndex].answer">
                
              <div  @click="removeChoice(choiceIndex)" class="dragElement selected" :class="{'correct':question.commited && choice.answer.indexOf(choice.correct_match)==0, 'incorrect':question.commited && choice.answer.indexOf(choice.correct_match)!=0}" v-for="choiceEl in choice.answer">{{choiceEl}}</div>
              </draggable>

            </div>
            <div v-if="question.commited && !paid">Answer submitted. Click Continue to proceed.</div>
            <button v-if="!question.commited" @click="answerDraggable(question)">Submit</button>
            <button v-if="question.commited && question.explanation_input" @click="showExplanation=true">Show Explanation</button>
          </div>
        </div>
</template>

<script>
import Vue from 'vue'
import VueSticky from '../Helpers/sticky.js'
import draggable from 'vuedraggable'

    export default {
          name: 'multi-drag-match',
          props: ['question', 'paid'],
          components: {
            draggable
          },          
          directives: {
          'sticky': VueSticky,
          },
          data(){
            return {

            }
          },
          methods:{
            removeChoice(choiceIndex){
              var vm = this;
              console.log(choiceIndex);
              Vue.set(vm.question.drag_and_match[choiceIndex], 'answer', []);
              var drag_and_match = vm.question.drag_and_match;
              vm.question.drag_and_match = [];
              vm.question.drag_and_match = drag_and_match;
              


              // Vue.set(vm.questions, vm.currentQuestionIndex, Vue.util.extend({}, vm.questions[vm.currentQuestionIndex]));
            },
            checkMove: function(evt){
              // console.log(evt);
              let from = evt.draggedContext;
              let to   = evt.relatedContext;
              // evt.dragged.classList.add('amazing');
              // res = this.privateCheckMove(evt)
              // this.canDrag=res;
              // this.futureIndex = evt.draggedContext.futureIndex;
              if(evt.to.id == 'questionBox'){
                return true;
              }
              else if(to.list.length == 0){
                return true;
              }
              else if(to.list.length == 1){
                return false;
              }
              else{
                return false;
              }
            },
            checkMoveInner: function(evt){
              var vm = this;
              // console.log(evt);
              let from       = evt.draggedContext;
              let fromIndex  = parseInt(evt.from.dataset.index)
              let to         = evt.relatedContext;
              let toIndex    = parseInt(evt.to.dataset.index)
              // evt.dragged.classList.add('amazing');
              // res = this.privateCheckMove(evt)
              // this.canDrag=res;
              // this.futureIndex = evt.draggedContext.futureIndex;
              if(evt.to.id == 'questionBox'){
                return true;
              }
              else if(from.futureIndex == 1){
                // console.log('swap1', evt);
                // if(evt.from && evt.to)
                var fromOrig    = vm.questions[vm.currentQuestionIndex].drag_and_match[fromIndex].answer
                var toOrig      = vm.questions[vm.currentQuestionIndex].drag_and_match[toIndex].answer

                from    = toOrig.slice();
                to      = fromOrig.slice();
                // fromVal = vm.questions[vm.currentQuestionIndex].drag_and_match[from].answer
                // toVal   = vm.questions[vm.currentQuestionIndex].drag_and_match[from].answer
                console.log('swap', from, to)
                          // vm.swap(parseInt(evt.from.dataset.index), parseInt(evt.to.dataset.index));

                return false;
              }
              else if(to.list.length == 0 || to.index == -1){
                return true;
              }
              else if(to.list.length == 1){
                return false;
              }
              else{
                return false;
              }
            },
            answerDraggable: function(question){
                console.log('emitting answer');
                this.$emit('answer', {question} );
            },
            _makeChoiceAnswers: function($event, question){
              var vm = this;
              console.log(question);
              var drag_and_match = vm.question.drag_and_match;
              vm.question.drag_and_match = [];
              vm.question.drag_and_match = drag_and_match;
              // vm.$set("question",question);
            },
          },

          computed: {
            currentAcceptableQuestionAnswer: function(){
              var vm = this;
              var question = vm.question;

              console.log('question', question);
              var correctArray = [];
              var incorrectArray = [];

              for (var i = 0; i < question.answers_multiple.length; i++) {
                  console.log(question.answers_multiple[i]);

                  if(question.answers_multiple[i].is_correct && !question.answers_multiple[i].selected){
                    correctArray.push(String.fromCharCode(i+65) + '-✔');
                  } else if ( !question.answers_multiple[i].is_correct && question.answers_multiple[i].selected) {
                    correctArray.push(String.fromCharCode(i+65) + '-✖' );
                  }

              }

              return correctArray.join(', ');


            }
          }
    }
</script>


// WEBPACK FOOTER //
// MultiDragAndMatch.vue?1a4e1c55